import { render, staticRenderFns } from "./Categories.vue?vue&type=template&id=5d7f8a98"
import script from "./Categories.vue?vue&type=script&lang=ts"
export * from "./Categories.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports